import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            w: '100%',
            maxW: remCalc(688),
            margin: '0 auto',
            overflow: 'hidden',
            backgroundColor: 'background.light',
            display: 'flex',
            flexDirection: 'column',
            padding: {base: remCalc(24), lg: remCalc(40)},
        },
        contentContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: {base: 'center', lg: 'flex-start'},
            padding: {base: remCalc(24), lg: remCalc(40)},
        },
        title: {
            fontSize: remCalc(24),
            lineHeight: remCalc(26),
            color: 'text.default',
            fontWeight: '500',
            mb: remCalc(16),
        },
        description: {
            textStyle: 'body-medium',
            color: 'text.default',
            mb: remCalc(24),
            maxW: {base: 'unset', lg: remCalc(500)},
        },
    },
}
